const en = {
    "errors": {
        "authenticationError": "Authentication Failed: Unable to authenticate. Please log in again.",
        "sessionError": "Session Expired: Your Session has expired. Please log in again.",
        "serverError": "There is some Error in the server. Please try again later."
    },
    "commonTexts": {
        "fulfilled": "Fulfilled",
        "unfulfilled": "Unfulfilled",
        "completed": "Completed",
        "proceed": "Proceed",
        "order": "Order",
        "date": "Date",
        "customer": "Customer",
        "action": "Action",
        "block": "block",
        "none": "none",
        "support": "Support",
        "faq": "FAQ's",
        "issues": "Issues",
        "logout": "Log Out",
        "na": "N/A",
        "nill": "Nill",
        "gst": "gst-incl",
        "noContent": "no-content",
        "title": "Title",
        "description": "Description",
        "terms": "Terms & Conditions"
    },
    "giftCardTable": {
        "giftCard": "Gift Card",
        "image": "Image",
        "createdDate": "Created Date",
        "action": "Action"
    },
    "customPlanCard": "We provide more flexible plans for enterprise. Please contact us to get the ultimate solution for you.",
    "dashboardMenu": {
        "analytics": "Analytics",
        "home": "Home",
        "account": "My Account",
        "plan": "My Plan",
        "invoice": "My Invoices",
        "currentUsage": "Current Usage",
        "publishGc": "Publish Gift Card",
        "giftcardSku": "Gift Card SKU’s",
        "giftcardOrders": "Gift Card Orders",
        "manageTemplates": "Manage Email Templates",
        "storeCredit": "Store Credit",
        "gcCreditRefunds": "Store-Credits & Refunds",
        "registration": "Registration Status",
        "preferences": "Preferences"
    },
    "pagination": {
        "firstPage": "You are already in First Page",
        "activePage": "activePage",
        "lastPage": "You are already in Last Page"
    },
    "plancard": {
        "mostPopular": "Most Popular",
        "gst": "+GST",
        "create": "Create store credits & gift cards",
        "upto": "up to",
        "usage": "Usage fee for issuance above limit",
        "insuance": "of value of issuance",
        "maxIssuance": "Max issuance as per plan is",
        "year": "/Annual",
        "month": "'/Month'"
    },
    "footer": {
        "privacy": "Privacy Policy",
        "terms": "Terms and Conditions",
        "copyright": `Copyright © 2023`
    },
    "account": {
        "noPlan": "No Active Plan",
        "upgradePlan": "Upgrade Plan",
        "linkStore": "Linked Store Contact",
        "storeName": "Store Name",
        "email": "Contact Email"
    },
    "currentUsage": {
        "currentPlan": "Current Plan",
        "previousPlan": "Previous Plan",
        "subscriptionFee": "Subscription Fee",
        "usageFee": "Usage Fee (at {{ value }}% of Value Issuance)",
        "notAvailable": "Currently Not Available"
    },
    "myInvoice": {
        "planName": "Plan Name",
        "invoiceDate": "Invoice Date",
        "invoiceNumber": "Invoice Number",
        "amount": "Amount",
        "nextPayment": "Next Payment Date",
        "noOrders": "There is no orders currently."
    },
    "dashboardHome": {
        "description1": `Welcome to <strong>{{appName}}</strong> One stop solution for all your brand currency needs!`,
        "description2": "Kindly reach out to our team to initiate your KYC and onboarding.",
        "description3": "Write to us at - <b>care.ib@pinelabs.com</b>",
        "description4": `<p>You are now one step away from activating {{appName}} solution. </p>
            <p>Kindly complete the payment to access the solution over your Shopify store</p>
        `,
        "proceed": "Proceed to Payment",
        "welcome": "Welcome to Your Dashboard",
        "congrats": "Congratulations! You now have complete access to {{appName}} solution for your Shopify store.",
        "rating": "Give us rating in Shopify app store"
    },
    "kycProgress": {
        "dashboard": "Your Qwikcilver dashboard active.",
        "secure": "Easily and securely manage all your store credits and gift cards.",
        "registration": "Registration status - Progress",
        "activation": "Your account will be activated within 2 hours."
    },
    "analytics": {
        "selectDate": "Select a Date Range",
        "pickDate": "Pick a date range",
        "totalGcIssued": "Total Gift Cards Issued",
        "gcOvertime": "Gift Card Metrics over Time",
        "totalWallets": "Total Wallets",
        "walletRedeemCount": "Wallet Redeemed Count",
        "redeemPercentage": "Redeemed Percentage",
        "outstandingBalance": "Total Outstanding Balance",
        "walletOvertime": "Wallet Metrics over Time",
        "gcWallet": "Giftcard & Wallet",
        "redeem": "Redeem",
        "refund": "Refund",
        "totalCardsIssues": "Total Issued Cards",
        "totalRedeemedCards": "Total Redeemed Cards",
        "avgRedeemptionTime": "Average Time Between Issuance & Redemption",
        "cardNumber": "Card Number",
        "redeemedAmount": "Redeemed Amount",
        "initialValue": "Initial Value",
        "redemptionRate": "Redemption Rate",
        "previous": "Previous",
        "next": "Next",
        "page": "Page",
        "of": "of",
        "totalRefundedAmt": "Total Amount Refunded to GC",
        "totalGcRefunds": "Total GC Refunds",
        "totalWalletRefunds": "Total Wallet Refunds",
        "totalWalletRefundAmt": "Total Wallet Refund Amount",
        "gcRefundTrends": "GC Refund Trends",
        "refundDetails": "Refund Details",
        "date": "Date",
        "gcRefundAmt": "GC Refund Amount",
        "gcRefundCount": "GC Refund Count",
        "walletRefundAmt": "Wallet Refund Amount",
        "walletRefundCount": "Wallet Refund Count"
        
    },
    "emailTemplates": {
        "send": "Send",
        "back": "Back",
        "save": "Save",
        "cancel": "Cancel",
        "enterTestEmail": "Enter email address",
        "noTemplates": "No Available Email Templates Found",
        "selected": "Selected",
        "select": "Select",
        "customise": "Customise",
        "view": "View",
        "tryAgain": "Try Again",
        "buyForSelf": "Buy For Self",
        "sendAsGift": "Send as Gift",
        "emailPreview": "Email Preview",
        "emailSubject": "Email Subject:",
        "enterSubject": "Enter email subject",
        "senderName": "Sender Name:",
        "senderEmail": "Sender Email Address:",
        "enterSenderName": "Enter sender's name",
        "enterSenderEmail": "Enter sender's email address",
        "templateCustomisations": "Template Customisations:",
        "merchantMessage": "Merchant Message",
        "thankyouMessage": "Thank you Message",
        "brandImage": "Select brand image",
        "addNewImage": "Click to add new image",
        "emailConfiguration": "Email Configuration",
        "sendTestEmail": "Send Test Email",
        "templateUpdated": "Template updated successfully",
        "testEmailSuccess": "Email sent successfully",
        "testEmailError": "Please enter the email address to send the test email",
        "editBannerImage": "Edit banner image",
        "tooltipInfo": "Changing the sender name will send the emails into spam if it is not verified.",
        "addCoverImage": "Add cover image",
        "importCategoryImage": "Import category image",
        "selectCategoryImages": "Select a style for your Gift Card",
        "addNewCategory": "+ Add new category",
        "enterCategoryName": "Enter category name",
        "selectCoverImage": "Select a theme for your Gift Card",
        "submit": "Submit",
        "enterEmailSubject": "Enter email subject"
    },
    "createGiftcard": {
        "import": "Save",
        "newImage": "Import image",
        "loadTemplates": "Load From Templates",
        "noTemplates": "No Available Templates Found. Please add an image.",
        "minImageError": "Please select atleast one image",
        "importSuccess": "Imported Successfully",
        "selectImage": "Please select an image file.",
        "modelImageInvalid": "Image dimensions are invalid. Please upload an image with dimensions 600x250 px. Your image dimensions are: ",
        "invalidDimensions": "Image dimensions are invalid. Please upload an image with dimensions 600x250 px. Your image dimensions are: ",
        "change": "Change image",
        "sendBarcode": "Send Barcode in Email to User",
        "validity": "Validity",
        "noExpiry": "No Expiry",
        "variantName": "Variant Name",
        "denomination": "Denomination",
        "addVariant": "Add a Variant",  
        "publicGc": "Create & Publish Gift Card",
        "alert": "Image dimensions are invalid",
        "titleError": "* Title can't be empty (min 4)",
        "variantError": "* Variants can't be empty",
        "imageError": "* Min 1 image required",
        "emptyValidity": "* Validity can't be empty",
        "validityError": "Please select Validity",
        "error": "Something went wrong!",
        "gcPrice": "Gift Card Price",
        "years": "Years",
        "months": "Months",
        "minValue": "Min Value :",
        "maxValue": "Max Value:",
        "enableDenomination": "Enable Variable Denomination",
        "emptyDenomination": "Please set min and Max values",
        "denominationValidation": "Max value should be greater than min",
        "GcPurchaseQuantity": "Set limit for giftcard purchase quantity",
        "buyForSelfQuantity": "Set buy for self purchase quantity",
        "sendAsGiftQuantity": "Set send as gift purchase quantity",
        "descriptionError": "* Description can't be empty (min 3 characters)", 
        "termsError": "* Terms & Conditions can't be empty (min 3 characters)", 
        "quantityError": "* Quantity fields can't be empty or invalid",
        "quantityValidationError": "* Quantity must be between 1 to 10",
    },
    "editGiftCard": {
        "active": "Active Account",
        "gcValidity": "Gift Card Validity",
        "appendVariant": "Append a Variant",
        "save": "Save"
    },
    "giftCardList": {
        "gcSku": "Gift Card SKU's"
    },
    "resendGc": {
        "orderNumber": "Order Number",
        "noResults": "No matching results",
        "noGiftcards": "There are no Gift cards"
    },
    "issues": {
        "haveIssue": "Have an Issue?",
        "reachOut": `Please use Qwikcilver’s Support Dashboard to raise any Issues you are
          facing.
        `,
        "click": "Click Here.",
        "access": "To Access the dashboard"
    },
    "logout": "You are successfully logged out.",
    "paymentFailed": "Unfortunately, the trasaction has failed.",
    "confirmation": {
        "thanksMsg": "Thanks for signing up for Qwikcilver Gift Card Program",
        "activation": "Your account will be activated within 2 hours."
    },
    "faqPage": {
        "faqs": "FAQ's",
        "aboutCompany": "ABOUT QWIKCILVER",
        "functionalities": `
            <li>
                <p>
                    What are the functionalities, that I will get from the
                    Qwikcilver Refunds & Gift Cards App?
                </p>

                <p>
                    Using the Qwikcilver App, a merchant can achieve the following
                    business functionalities.
                </p>
                <ul>
                    <li>
                    Allow your customers to purchase gift cards from your online
                    store
                    </li>
                    <li>
                    Allow your staff to effortlessly issue e-refunds against
                    returned orders
                    </li>
                </ul>
            </li>
            <li>
                <p>
                    Why should I use Qwikcilver App for generating gift cards and
                    e-refunds?
                </p>
                <p>
                    The Qwikcilver platform is trusted by India’s leading retail
                    &amp; e-commerce brands to manage their gift cards and
                    e-refunds issuances. Some of the brands using the Qwikcilver
                    platform include Amazon, Uber, Flipkart, Myntra, Nykaa,
                    ClearTrip, Tata Cliq, Lifestyle, Shoppers Stop, Titan and many
                    more. Since gift cards and e-refunds are equivalent to brand
                    currency, and Qwikcilver follows the highest security
                    standards during their issuance &amp; redemption. Besides the
                    various business benefits, the Qwikcilver platform allows
                    merchants to seamlessly track every issuance and redemption of
                    gift cards through comprehensive reports.
                </p>
            </li>
            <li>
                <p>
                    What are the business benefits of using the Qwikcilver App to
                    issue gift cards and e-refunds to customers?
                </p>
                <p>
                    The following are the five main benefits for promoting gift
                    card as a product on your online store:
                </p>
                <ul>
                    <li>
                        Merchant receives upfront money for a service to be rendered
                        at a later date
                    </li>
                    <li>
                        Guaranteed uplift (or spends over-and-above the gift card
                        value), on every redemption transaction
                    </li>
                    <li>
                        New prospective customers and referrals (through personal
                        &amp; corporate gifting using gift cards)
                    </li>
                    <li>
                        Prospect of bulk revenues (from large rewards catalogs)
                    </li>
                    <li>
                        Chances of gift cards going un-redeemed (called breakage)
                    </li>
                </ul>
                <p>
                    The following are the five main benefits for having e-refunds
                    OR store-credit program:
                </p>
                <ul>
                    <li>
                        Store-Credits can help D2C merchants manage and track
                        refunds more efficiently
                    </li>
                    <li>
                        For COD Orders that need to be refunded, an e-refund or
                        store-credit is more convenient and cost effective than a
                        bank transfer / bank cheque. No need to collect bank details
                        from customers.
                    </li>
                    <li>
                        For Pre-paid Orders that needs to be refunded, e-refunds or
                        store-credits can help merchants retain the cash flow from
                        the original order
                    </li>
                    <li>
                        By retaining the customer, the merchant can also save on the
                        entire gamut of costs, that would have originally been
                        incurred for acquiring and servicing the customer
                    </li>
                    <li>
                        E-refunds are credited instantly to customers, for use
                        immediately on the next order, thereby ensuring customer
                        delight and stickiness
                    </li>
                </ul>
            </li>
            <li>
                <p>
                    Can I generate gift cards in bulk using the Qwikcilver app?
                </p>
                <p>
                    The bulk generation of gift cards is available for
                    Qwikcilver’s Enterprise clients. Please reach out to
                    <a href="mailto:care@qwikcilver.com">
                    care@qwikcilver.com
                    </a>{" "}
                    to start a conversation to migrate you to an Enterprise Plan.
                </p>
            </li>
        `,
        "merchantOnboard": "MERCHANT ONBOARDING",
        "onboardingFeatures": `
            <li>
                <p>
                    What are the merchant onboarding details, that I need to
                    provide to Qwikcilver?
                </p>
                <p>
                    While registering on the Qwikcilver App, a merchant needs to
                    provide the Business PAN number, CIN Number, GST Number and
                    the Billing / Communication address.
                </p>
            </li>
            <li>
                <p>
                    How long will it take to get my account to be activated after
                    submitting the onboarding details and completing the payment?
                </p>
                <p>
                    Once the merchant completes the subscription payment,
                    Qwikcilver strives to set up the merchant on its systems as
                    quickly as possible. This initial configuration usually is
                    done under 1 to 2 hours.
                </p>
            </li>
            <li>
                <p>
                    How can I access my Qwikcilver Refunds &amp; Gift Cards
                    Dashboard?
                </p>
                <p>
                    The Qwikcilver dashboard can be accessed only via the Shopify
                    account. Please login to your store dashboard using your
                    Shopify credentials, and then navigate to the Apps section on
                    the Left Navigation Menu.
                </p>
            </li>
        `,
        "configurationTitle": "MERCHANT CONFIGURATIONS",
        "configurationFeatures": `
            <tr>
                <th>Steps</th>
                <th>Configuring the Qwikcilver App</th>
                <th>Configuration Location</th>
                <th>Spcial Remarks</th>
            </tr>
            <tr>
                <td>Step 1</td>
                <td>Configure Currency & Markets </td>
                <td>Shopify Admin Settings</td>
                <td>
                <b>
                    Important: These currency & market settings are must for
                    the Qwikcilver App
                </b>

                <ol>
                    <li>Store currency has to be INR</li>
                    <li>
                    Market has to be India. In the current version, the App
                    supports only one market at a time.
                    </li>
                    <li>
                    Disable all other markets other than India (In
                    Settingss=&gt Markets)
                    </li>
                    <li>
                    Disable Other Country Customers paying in Local Currency
                    (in Settings=&gt; Markets =&gt; Preferences =&gt;Pricing
                    =&gt; Local Currencies)
                    </li>
                    <li>
                    Timezone has to be GMT+5:30 (Chennai, Kolkata, Mumbai,
                    New Delhi)
                    </li>
                </ol>
                </td>
            </tr>
            <tr>
                <td>Step 2</td>
                <td>Create & Apply Gift Card SKU Template</td>
                <td>
                In Shopify UI Customiser & In Qwikcilver App Dashboard
                </td>
                <td>
                Please ensure you have an image with ratio (width x height)
                600x250 px to create the gift card SKU
                </td>
            </tr>
            <tr>
                <td>Step 3</td>
                <td>Add-to-Wallet & Wallet Transaction Screens</td>
                <td>In Shopify UI Customiser</td>
                <td>
                Please ensure you have a test account for your website
                store-front
                </td>
            </tr>
            <tr>
                <td>Step 4</td>
                <td>Add Checkout Extension</td>
                <td>In Shopify UI Customiser</td>
                <td>
                This feature is available only for Shopify Plus Merchants
                </td>
            </tr>
        `,
        "giftCardRedemption": "PURCHASE AND REDEMPTION OF GIFT CARDS",
        "giftCardRedemptionInfo": `
            <li>
                <p>How can my customers see gift cards on my online store?</p>
                <p>
                    Once your Gift Card SKU is active on the Shopify dashboard,
                    your customers can easily search and discover the gift card
                    SKU. However, to aid the discovery of your gift card SKU,
                    please add the same to your product navigation menu. Our
                    merchants get higher gift card sales, on promoting the product
                    through site banners and special pages.
                </p>
            </li>
            <li>
                <p>
                    What are the different ways in which my customer can purchase
                    the gift cards?
                </p>
                <p>
                    Customers have the following two options to purchase the gift
                    cards:
                </p>
                <ol type="1">
                    <li>
                        Buy-for-Self: Customers who want to use gift cards for
                        self-consumption on the merchant store, can use this option.
                        Purchasing a gift card using this option will automatically
                        add the gift card, to an online wallet, that Qwikcilver
                        maintains on behalf of the merchant. All gift cards in the
                        customer’s online wallet can be redeemed as part of the
                        Shopify Check-Out flow.
                    </li>
                    <li>
                    Send-As-A-Gift: Customers who want to send the gift cards to
                    friends and family can use this option. Here the customer
                    must enter the recipient’s email details, and the gift card
                    is securely delivered to the recipient via email.
                    </li>
                </ol>
            </li>
            <li>
                <p>
                    What is the Add-to-Balance functionality for the gift cards
                    send by email?
                </p>
                <p>
                    To ensure greater security and convenience for your customers,
                    the Qwikcilver app creates a secure gift card wallet for your
                    customers to store gift cards received from family, friends
                    and other entities (i.e. Employers, Corporate Promotions etc).
                    Customers can simply add the Gift Card Code, received on email
                    to get the gift card added to the wallet.
                </p>
            </li>
            <li>
                <p>
                    How can my customers redeem the gift cards purchased from my
                    online store?
                </p>
                <p>
                    The gift card redemption on your online store would work as
                    follows:
                </p>
                <p>A. For Merchants on the Shopify Plus Plan:</p>
                <ol type="I">
                    <li>
                    Customers have to first login to their account (i.e.
                    merchant website).
                    </li>
                    <li>
                    On successful login, the Qwikcilver app displays the
                    available balance mapped to the customer’s gift card wallet.
                    </li>
                    <li>
                    The Customer can Apply this gift card balance, as part of
                    the Shopify check-out flow
                    </li>
                </ol>
                <p>B. For Merchants on the Shopify Basic Plans:</p>
                <ol type="I">
                    <li>
                    Customers have to first login to their account (i.e.
                    merchant website).
                    </li>
                    <li>
                    On successful login, the Qwikcilver app displays the
                    available balance mapped to the customer’s gift card wallet.
                    </li>
                    <li>
                    From this screen, the Customer can Copy the Gift Balance
                    Code, and paste the same on the Shopify check-out page
                    </li>
                </ol>
            </li>
            <li>
                <p>
                    Can my customers redeem these gift cards at my offline stores
                    (i.e. retail store points)?
                </p>
                <p>
                    The gift cards &amp; store credits issued by the Qwikcilver
                    app can be seamlessly accepted at retail checkout; ONLY if
                    your offline stores (retail store points) are using the
                    Shopify POS system.
                </p>
                <p>
                    For merchants using a different POS application, Qwikcilver is
                    currently working on enabling the gift cards &amp; e-refunds
                    as part of retail check-out. Please drop us a mail at
                    <a href="mailto:care@qwikcilver.com">care@qwikcilver.com</a>,
                    and we will keep you posted as soon as this feature is made
                    available on the Qwikcilver app.
                </p>
            </li>
        `,
        "storeCredit": "CREATING STORE CREDITS",
        "storeCreditInfo": `
            <li>
                <p>
                    How can I create store-credits OR e-refunds using the
                    Qwikcilver App?
                </p>
                <p>
                    Please follow the step-by-step actions mentioned below to
                    start generating store credits for your customers:
                </p>
                <ol type="1">
                    <li>
                        Please login to the Qwikcilver App through your Shopify
                        Account.
                    </li>
                    <li>
                        Thereafter select Store Credits from the left navigation
                        menu.
                    </li>
                    <li>
                        This page will list all the orders eligible for refunds, as
                        fetched from your Shopify dashboard.
                    </li>
                    <li>
                        Select the order that you want to refund, and click the
                        proceed button.
                    </li>
                    <li>
                        After you input the refund amount, and confirm, the
                        Qwikcilver app will instantly generate the e-refund for the
                        customer, and map the amount to his/her online store
                        account.
                    </li>
                    <li>
                        The customer will be able to use this e-refund after login
                        to his/her online store account.
                    </li>
                </ol>
            </li>
            <li>
                <p>
                    Can I use the Qwikcilver refunds dashboard for processing
                    refunds back-to-source (i.e. back to the original payment
                    instrument)?
                </p>
                <p>
                    Yes, the Qwikcilver dashboard can be used for initiating
                    refunds back-to-source. In the refund confirmation screen,
                    please select back-to-source from the drop-down options.
                </p>
                <p>
                    On confirming the Back-to-source option, you will be
                    redirected to the Shopify Refunds page, where the action can
                    be completed. Please note that this action is completed by
                    Shopify through the Payment Gateway integrated on your
                    website. Qwikcilver plays no role in crediting a
                    back-to-source refund, and you will need to check with your
                    payment gateway for any details regarding these transactions.
                </p>
            </li>
        `,
        "merchantReports": "MERCHANT REPORTS",
        "merchantReportsInfo": `
            <li>
                <p>
                  How can I track the gift cards and e-refunds (store-credits)
                  issued through the Qwikcilver App?
                </p>
                <p>
                  The Qwikcilver app sends a daily report for merchants
                  detailing the gift cards that are activated and redeemed.
                </p>
            </li>
            <li>
                <p>
                  Will I be able to see the unspent / unused balances at a card
                  level?
                </p>
                <p>
                  Yes, Qwikcilver’s detailed transaction report will help you on
                  this aspect.
                </p>
            </li>        
        `,
        "billing": "BILLING",
        "billingInfo": `
            <li>
                <p>What is the billing cycle for a merchant?</p>
                <p>
                  A merchant that is onboarded during the middle of the month is
                  billed on a pro-rata basis. Thereafter the merchant is billed
                  in calendar month cycles.
                </p>
            </li>
            <li>
                <p>How does my subscription plan work?</p>
                <p>
                  Qwikcilver has a very transparent pricing plan that allows
                  merchants to issue gift cards & store-credits for their
                  customers:
                </p>
                <p>
                  Each subscription plan (for example: Basic Plan of Rs.
                  399+GST) allows the merchant to issue gift cards up-to a
                  certain limit (for example: Rs. 20,000).
                </p>
            </li>
            <li>
                <p>
                  What are the feature differences across the Basic, Pro, and
                  Premium Plans?
                </p>
                <p>
                  The feature differences across the plans are detailed on the
                  App Pricing Page.
                </p>
            </li>
            <li>
                <p>How can I upgrade my current subscription plan?</p>
                <p>
                  A merchant can upgrade the Subscription plan from the
                  Qwikcilver App dashboard. Please select the desired plan and
                  make the payment, and you will be upgraded immediately.
                </p>
            </li>
            <li>
                <p>How can I downgrade my current subscription plan?</p>
                <p>
                  A merchant can downgrade the Subscription plan by sending an
                  email to
                  <a href="mailto:care@qwikcilver.com">care@qwikcilver.com</a>.
                  Please share your Shopify ID for easy tracking and resolution
                  of your request.
                </p>
            </li>
            <li>
                <p>How can I cancel my subscription plan?</p>
                <p>
                  [To be finalised] In the event where a merchant wants to
                  discontinue using the Qwikcilver App, the merchant can cancel
                  the subscription from the Qwikcilver App dashboard.
                </p>
            </li>
            <li>
                <p>When will the cancellation come into effect?</p>
                <p>
                  Cancel of Subscription always comes to effect from the
                  subsequent month onwards.
                </p>
            </li>
            <li>
                <p>
                  What are the implications of uninstalling the Qwikcilver app
                  from the Shopify account?
                </p>
                <p>
                  Uninstalling the Qwikcilver app will prevent your legitimate
                  customers from redeeming their gift card on your online store.
                  In case you want to discontinue using the Qwikcilver app, you
                  can cancel the subscription plan from the app dashboard.
                </p>
            </li>
        `,
        "customerSupport": "CUSTOMER SUPPORT",
        "customerSupportInfo": `
            <li>
                <p>Does Qwikcilver provide Customer Support?</p>
                <p>
                  Qwikcilver provides a Service dashboard (called Support
                  Central), where merchants can raise support tickets for
                  blocking gift cards, unblocking gift cards, and extending
                  expiry of issued cards, etc. These support tickets are
                  resolved as quickly as possible by Qwikcilver, to avoid
                  business disruptions for the merchants.
                </p>
            </li>
            <li>
                <p>
                  How can I resolve any issues related to the Qwikcilver app
                  integration with my website?
                </p>
                <p>
                  Qwikcilver’s Support Central dashboard also has a dedicated
                  section to help merchants raise requests for any
                  integration-related issues. You can also reach us on{" "}
                  <a href="mailto:care@qwikcilver.com">care@qwikcilver.com</a>
                  with your issue, and we will resolve it at the earliest.
                </p>
            </li>
        `
    },
    "planSelection": {
        "contact": "Contact",
        "alert": "Please accept Terms and Conditions.",
        "issuance": "Start issuing store credits & gift cards to your customers",
        "select": "Select a package",
        "pay": "Pay Now",
        "compare": "Compare {{appName}} Benefits",
        "accept": "I accept {{ appName }} App",
        "networkError": "Network response was not OK.",
        "enterprise": "Enterprise",
        "plansList": {
            "title1": "Issue digital gift card & store credits",
            "title2": "Online wallet for end users (for adding gift cards & store credits)",
            "title3": "Pre-packaged templates for e-gift cards",
            "title4": "Fixed denominations",
            "title5": "Variable denominations",
            "title6": "Issue physical gift card",
            "title7": "Bulk Issuance Tool",
            "title8": "Scheduled Reports: Daily, Weekly, Monthly",
            "title9": "Report dashboard for all gift card and store credit transactions",
            "title10": "Omni channel integration (Store POS, Website, Mobile app)",
            "title11": "Customised Issuance and Redemption rules",
            "title12": "Distribution in Corporate & Online channels",
            "title13": "Retail Distribution as per requirements (online to off-line)"
        },
        "table": {
            "features": "Qwikcilver App Features",
            "basic": "Basic",
            "pro": "Pro",
            "premium": "Premium",
            "enterprise": "Enterprise"
        },
        "note": `Note: Some of the features mentioned in the Enterprise Plan may need
            additional integrations with Qwikcilver API's & product modules. This
            will be implemented separately as per Merchant's requirements
        `,
        "terms": {
            "title": "TERMS AND CONDITIONS GOVERNING THE QWIKCILVER APP GIFT CARD PROCESSING SERVICES",
            "bullet1": `The Merchant Issuer is desirous of issuing the Gift card and launching the
                  gift card program by leveraging the technical capabilities and services of
                  Pine Labs. This Agreement describes the framework upon which Pine Labs
                  has agreed to offer (i) its gift card solutions (<b>“gift cards”</b>), to the Merchant
                  (<b>“Merchant Issuer”</b>). The specifications, scope and the manner in which
                  the solutions will be provided are set out in <b>Annexure A</b> hereto (“Project”).
            `,
            "bullet2": `The products covered by this Agreement consist of the gift cards, software
                  applications and other devices, if any, provided by Pine Labs for the
                  purposes of the Project.
            `,
            "bullet3": `The commercial terms agreed by the parties for the purposes of the Project
                  are set out in <b>Annexure B</b> hereto.
            `,
            "bullet4": `The primary responsibilities of the Merchant Issuer are set out in Annexure
                  C hereto. Each Party will designate a representative to act as the primary
                  point- of-contact for the purposes of this Agreement.
            `,
            "bullet5": `Subject to the limitation of liability, each party shall indemnify, defend and
                  hold harmless the other from and against any and all direct damages,
                  liability, losses, costs and expenses (including reasonable attorneys’ fees)
                  relating to or arising out of the breach of this Agreement, the negligence or
                  willful misconduct of either party, or its employees or agents.
            `,
            "bullet6": `Pine Labs shall endeavor to ensure that its products and services meet the
                  specifications set out herein in all material aspects, at the time of
                  implementation. If the Merchant Issuer is of the opinion that Pine Labs
                  products or services do not conform to the specifications set out herein,
                  Pine Labs will use commercially reasonable efforts to correct or remedy
                  such non-conformance.
            `,
            "bullet7": `For the avoidance of doubt, it is hereby clarified that the Merchant Issuer
                  shall, at all times, be the issuer under law, of the gift cards issued under
                  this Agreement. Pine Labs shall be the technology partner powering the gift
                  card program, under instructions from the Merchant Issuer. Pine Labs
                  products and services are provided on an “as is” basis. Except as
                  expressly stated in Clause 6, Pine Labs hereby disclaims all express and
                  implied warranties, including, without limitation, any implied warrantiesof
                  merchantability and fitness for a particular purpose.
            `,
            "bullet8": `<b>Confidentiality:</b> Each party shall treat all data and information including
                the commercial terms and the terms and conditions agreed between the
                parties hereunder (including Cardholder information), (<b>"Confidential
                Information"</b>), disclosed to it or which comes into its possession or
                knowledge in connection with this arrangement as confidential. Further, the
                Merchant Issuer hereby agrees Pine Labs may use the personal
                information of the Merchant Issuer in any marketing or promotional
                activities associated with the Project at any time during the term of this
                Agreement.
            `,
            "bullet9": `Not withstanding anything stated in this arrangement, both parties agree
                that all proprietary intellectual property including, software, computer
                programs and systems generated by Pine Labs, on the server/systems of
                Pine Labs in relation to this arrangement, shall be the sole and exclusive
                property of Pine Labs.
            `,
            "bullet10": `Merchant Issuer will not and will not permit others to: (i) copy, adapt, alter,
                modify, merge or create derivative works of Pine Labs software
                applications; (ii) reverse-engineer, disassemble, or decompile Pine Labs
                software applications or otherwise attempt to determine its underlying
                source code; or (iii) sell, lease, sublicense or provide any portion of Pine
                Labs’ software applications to any third party.
            `,
            "bullet11": `While data/information relating to Merchant Issuer such as name, address,
                trademark, logo etc.(Merchant Issuer Data) is the exclusive property of
                Customer, Pine Labs is authorized to have legal and physical access to
                and make use of all such Merchant Issuer Data for purpose of performing
                the Services provided by Pine Labs through its Distribution channels and
                social media to facilitate sale of Merchant Gift Card and for purposes of
                data analysis and marketing in accordance with Pine Labs Privacy Policy. .
                Pine Labs and Qwikcilver are Trademarks owned and operated by Pine
                Labs Private Limited.
            `,
            "bullet12": "Upon termination or expiration of this Agreement: (i) any and all payment obligations of Merchant Issuer that have accrued shall become immediately due and payable; (ii) products issued prior to termination shall continue to be valid till the expiry of the product and the parties shall fulfill their respective obligations with respect to those Cards as if the arrangement is not terminated; (iii) Merchant Issuer shall promptly return to Pine Labs, its confidential information, software applications and all materials provided pursuant to this Agreement; (iv) Merchant Issuer shall uninstall Pine Labs software applications installed on its systems; and (v) Pine Labs will provide to the Merchant Issuer, an updated MIS setting out the details of all transactions undertaken by the customers of the Merchant Issuer, upto the effective date of termination of this Agreement.",
            "bullet13": "<b>Dispute Resolution:</b> Any and all disputes arising from this agreement shall be resolved through arbitration by a single arbitrator appointed by mutual agreement of the Parties, in accordance with the Arbitration and Conciliation Act, 1996.",
            "bullet14": "<b>Governing Law and Jurisdiction:</b> This Agreement shall be governed by the laws of India. Subject to Clause 14 above, nothing contained in this clause will preclude either party from applying for and obtaining any injunctive, prohibitory or other similar urgent or interim relief from a competent court of law, for which the courts at Delhi shall have exclusive jurisdiction.",
            "bullet15": "<b>Notices:</b> Any notices, requests and other communications required or permitted hereunder shall be in writing and shall be given by hand against written acknowledgement or receipt, or sent by registered mail, followed by a confirmation letter by registered mail, at or to each of the parties at the addresses set forth herein above.",
            "bullet16": "<b>Amendments:</b> This Agreement can be modified, supplement or amended only by written agreement executed by both parties.",
            "annexureA": `<h1>ANNEXURE A</h1>
                <h1>PROJECT AND SCOPE OF SERVICE</h1>
                <h2>A: For Launching and Managing the Gift Card Program</h2>
                <p>Pine Labs will provide the services to the Client to launch and manage the Gift Card Program on SaaS model.</p>
                <p>As part of the overall solution to the Client, Pine Labs will provide the following services:</p>
                <ol type="1">
                    <li>Will provide software for transaction initiation or redemption of cards at merchant’s online store.</li>
                    <li>Will setup gift card programs on Pine Labs server based on agreed program requirements with the Client;</li>
                    <li>Host and manage Pine Labs transaction processing server on the internet;</li>
                    <li>Manage all server-side maintenance, database back-ups and all regular management activities;</li>
                    <li>Authorize all Gift card transactions and capture transaction data for tracking, reconciliation, and reporting;</li>
                    <li>Provide a standard set of MIS reports for program tracking and settlement.</li>
                </ol>

                <h2>B: Process for Issuance of gift cards from Merchant Website:</h2>
                <ol type="1">
                    <li>Merchant should download the Pine Labs Plugin (also called Qwikcilver app) from Shopify App store and complete the KYC and onboarding processes.</li>
                    <li>Once Merchant is onboarded to Pine Labs platform, the merchant will be able to list Gift cards as a salable SKU on Merchant website.</li>
                    <li>Customer selects the quantity and denomination and makes payment via Payment gateway.</li>
                    <li>Upon successful payment processing, the customer gets the digital card which will have a 16-digit card number and separate 14-digit pin via email.</li>
                </ol>

                <h2>C: Process for Issuance of Refund Cards from Merchant Website:</h2>
                <ol type="1">
                    <li>Merchant should download the Pine Labs Plugin from Shopify App store and complete the KYC and onboarding processes.</li>
                    <li>Once Merchant is onboarded to Pine Labs platform, the merchant will be able to Issue Refund Cards (also called Store-Credits) using the plugin’s refund dashboard.</li>
                </ol>

                <h2>D: Process for Redemption of Refund Cards from Merchant Website:</h2>
                <ol type="1">
                    <li>Customer visits the Merchant Website with the e-gift card code.</li>
                    <li>Customer will need to add the gift card to the online merchant wallet, that Pine Labs will be creating for each customer desirous of redeeming gift card. This gift card balance will be updated instantly, once the customer uses the Add-to-Wallet Balance functionality on the merchant website.</li>
                    <li>Customer avails the product or service desired.</li>
                    <li>At the time of tendering, the customer will use the balance present in the online wallet for redemption.</li>
                    <li>Bill amount in excess of the Gift Card value should be collected by the merchant website directly via the payment gateway.</li>
                    <li>All support in relation to the transaction of the e-gift card will be handled by Pine Labs helpdesk.</li>
                </ol>
            `,
            "annexureB": `<div>
            <h1>ANNEXURE B</h1>
            <h1>COMMERCIAL TERMS</h1>
            <p>The commercials provided are for usage of the Technology platform provided for issuance and acceptance of the Merchant gift card.</p>
            <ol type="1">
              <li>For all Gift cards and refund cards issued by the merchant, Pine Labs will charge as per the Pricing Plan detailed below.</li>
              <li>Pine Labs reserves the right to change this Price Plan and Plan Features available for merchants at its discretion.</li>
              <li>This Plan will not be applicable in case Pine Labs and the Merchant enter into a separate commercial agreement with custom pricing for the issuance of gift cards and refund cards.</li>
            </ol>
            <div className="price-plans-image">
              {{ imagePlaceholder }}
            </div>
            <h2 className="text-center">Roles & Responsibilities</h2>
            <h3 className="text-center">Merchant’s Roles & Responsibilities</h3>
            <ol type="1">
              <li>Install the Pine Labs plugin (also called Qwikcilver app) from the Shopify App Store</li>
              <li>Complete the Online KYC Process, to help Pine Labs onboard the merchant to its Pine Labs Electronic Gift Card Management Platform</li>
              <li>Pay the monthly subscription as published by Pine Labs</li>
              <li>Configure the Pine Labs plugin as per the instructions of Pine Labs</li>
              <li>Enable the necessary internal mechanisms & processes to issue gift cards & refund cards to end customers</li>
              <li>After the sale (of gift cards) AND / OR distribution (of refund gift cards), the Card shall entitle the bearer of the said Card to shop for the amount mentioned on the Card on the Merchant’s Platform. The Merchant shall be responsible for allowing redemption of the Gift Card and will be responsible for providing clear instructions on how to redeem the same, to the customer.</li>
              <li>Merchant will be prompt in the payment of monthly subscriptions as per the due dates communicated by Pine Labs</li>
              <li>The Gift Card terms and conditions are set out in Exhibit A hereto.</li>
            </ol>
            <h2 className="text-center">Pine Labs Roles & Responsibilities</h2>
            <ol type="1">
              <li>Host and manage Pine Labs transaction processing server on the internet;</li>
              <li>Manage all server-side maintenance, database back-ups and all regular management activities;</li>
              <li>Help merchants issue gift cards and refund cards as per the pricing plan published on the Shopify platform;</li>
              <li>Store the details of gift cards and refund cards issued along with any customer data (as applicable);</li>
              <li>Authorize and Validate gift cards when presented for redemption on the merchant website;</li>
              <li>Process the redemption transactions and maintain the record of redemption transactions. Capture transaction data for tracking, reconciliation, and reporting;</li>
              <li>Publish a periodic report detailing the volume and value of transactions.</li>
            </ol>
          </div>
            `,
            "exhibitA": `<div>
                <h1>EXHIBIT A</h1>
                <h2 className="text-center">("Gift cards Terms & Conditions")</h2>
                <p>Terms and Conditions of Gift Card</p>
                <ol type="1">
                    <li>E-Gift Card is valid for a period of 6 months or 12 months (as applicable) from the date of its issue.</li>
                    <li>This Gift Card shall be subject to applicable laws or any new law, rules and/or regulations as may be promulgated / imposed by the Government, RBI, or any other statutory/regulatory authority.</li>
                    <li>No returns and no refunds on gift cards purchased through any channels.</li>
                    <li>E Gift Card is redeemable for merchandise at Merchant’s website and retail outlet within India. This Gift Voucher is redeemable during its validity.</li>
                    <li>E Gift Card is not redeemable for cash or credit nor can be exchanged for another Gift card.</li>
                    <li>If the invoice value is greater than the Gift Card value, the customer can pay the balance amount through Cash, Debit Card, and Credit Card as the case may be.</li>
                    <li>Merchant shall not be liable and responsible for any unauthorized and/or fraudulent purchase/s made using this E Gift Card.</li>
                    <li>The holder of this E Gift Card shall be solely responsible for the safe custody of the E Gift Card and the credentials mentioned on it. E Gift Card is a bearer instrument.</li>
                    <li>For balance enquiry & expiry, visit details, please add the gift card to your account / wallet on the merchant website.</li>
                    <li>Merchant reserves the right to amend the terms & conditions at its discretion without prior notice.</li>
                    <li>Disputes if any, shall be subject to Delhi jurisdiction.</li>
                    <li>E-gift cards are normally delivered instantly. But sometimes delivery can be delayed up to 24 - 48 hours.</li>
                </ol>
            </div>
            `
        },
        "close": "Close",
        "confirmation": "Are you sure you want to make payment towards {{appName}} Subscription plan",
        "yes": "Yes",
        "no": "No"
    },
    "planSuccess": {
        "success": "Congratulations! You now have complete access to {{appName}} solution for your Shopify store.",
        "support": `For any assistance regarding the utilization of the solution kindly refer to our <a href="/faqs">Support</a> or reach out to your assigned Program Manager.`
    },
    "refundSuccessMsg": "Your refund is processed successfully",
    "refundList": {
        "orderNo": "Order No.",
        "orderDate": "Order Date",
        "customerName": "Customer Name",
        "orderValue": "Order Value",
        "paymentStatus": "Payment Status",
        "originalPayment": "Original Payment",
        "fulfillmentStatus": "Fulfillment Status",
        "initiateRefund": "Initiate Refund",
        "refundMode": "Refund Mode",
        "refundStatus": "Refund Status"
    },
    "refundPage": {
        "failToLoad": "Failed to load refund details",
        "availableRefund": "Total available amount to Refund:",
        "discount": "Discount",
        "emailPlaceholder": "Enter Customer Email*",
        "refund": "Refund",
        "selectRefundType": "Select Refund Mode",
        "refundHistory": "Refund History",
        "transactionId": "Transaction Id",
        "date": "Date",
        "amount": "Amount",
        "refundType": "Refund Type",
        "status": "Status",
        "action": "Action",
        "resendEmail": "Resend Email",
        "completed": "Re-initiate Refund",
        "refundNo": "Refunding Order No",
        "toast": "Please set your store preferences before initiating the Refund!",
        "summary": "Summary",
        "subtotal": "Item Subtotal",
        "items": "Items",
        "disount": "Discount",
        "tax": "Tax",
        "refundTotal": "Refund Total",
        "refundAmount": "Refund Product Amount",
        "storeCredit": "Refund to Store-Credit",
        "backToSource": "Refund Back to Source",
        "inputAmountErr": "Please enter amount greater than or equal to 1",
        "emailError": "Please enter customer email address",
        "invalidEmail": "Please enter valid customer email address"
    },
    "refundSetting": {
        "preference" : "Store Credit Preferences",
        "info": "This settings allows you to credit the refund to a store credit.",
        "desiredAction": "What is the desired action? Select as Applicable",
        "paymentMode": "Payment Mode of Returned Order",
        "refundStoreCredit": "Refund to Store-Credit",
        "refundBackToSource": "Refund Back-to-Source",
        "payments": "Prepaid (CC / DC / UPI / Net Banking)",
        "cod": "Cash On Delivery",
        "giftCard": "Gift Card",
        "combination": "Combination of Prepaid & Gift Card",
        "restockType": "Restock Type",
        "backToSource": "Back-to-Source",
        "storeCredit": "Store-Credit",
        "locationId": "Location ID",
        "select": "Select",
        "return": "Return",
        "noRestock": "No Restock",
        "save": "Save"
    },
    "privacyPolicy": {
        "title": "WEBSITE PRIVACY POLICY",
        "heading1": "SCOPE",
        "website": "www.qwikcilver.com",
        "descrption1": "is an Internet based portal owned and operated by Pine Labs, a company incorporated under the laws of India, having its registered office at Pine Labs Private Limited, 207, Gupta Arcade, L.S.C. Plot No. 5, Mayur Vihar Phase-I Extension, New Delhi-110091, India. Use of the Website is offered to you conditioned on acceptance of all the terms, conditions, and notices contained in these Terms, along with any amendments made by Pine Labs at its sole discretion and posted on the Website.",
        "description2": `This Privacy policy (“Privacy Policy”) succinctly describes how we
          collect and use your information through a variety of digital means.
          You are advised to read the Privacy Policy carefully and provide your
          consent as appropriate when accessing or using this website on any
          computer, mobile phone, tablet, console or other device (collectively,
          “device”. This Privacy Policy applies to current and former visitors
          of the Website. By way of the Website, Pine Labs is inter alia engaged
          in the business of providing to its customers including you, end to
          end stored value card solutions by managing gift card, prepaid card
          and loyalty programs and facilitating distribution of gift and prepaid
          cards through various channels (collectively “Services”); This Privacy
          Policy is incorporated into, and is subject to, the Terms of Use.
        `,
        "heading2": "INFORMATION THAT IS OR MAY BE COLLECTED FROM YOU",
        "description3": `We may automatically receive and collect certain anonymous information
          in standard usage logs through our server, including
          computer-identification information obtained from "cookies" sent to
          your browser from various sources as detailed out in the Cookie notice
          section. We may actively collect the following personally identifiable
          information about you:
        `,
        "customer": {
            "name": "name including first and last name;",
            "email": "email address;",
            "contact": "mobile phone number and contact details;",
            "address": "address and postal code;",
            "opinion": "opinions of features on this Website;",
            "ip": "IP address",
            "preference": "product / service preferences; and",
            "other": `other information may be collected as per our registration process
            and as stipulated by applicable law, ancillary to availing of the
            different classes of Services provided by us.`
        },
        "info": "We may also actively collect the following personal data as below:",
        "bullet1": "about the pages you visit/access on this Website;",
        "bullet2": "the links you click on this Website;",
        "bullet3": "the number of times you access a particular page on this Website; and",
        "bullet4": "the number of times you have interacted on this Website.",
    },
    "termsConditions": {
        "title": "TERMS AND CONDITIONS GOVERNING THE QWIKCILVER APP GIFT CARD PROCESSING SERVICES",
        "bullet1": `The Merchant Issuer is desirous of issuing the Gift card and launching the
              gift card program by leveraging the technical capabilities and services of
              Pine Labs. This Agreement describes the framework upon which Pine Labs
              has agreed to offer (i) its gift card solutions (<b>“gift cards”</b>), to the Merchant
              (<b>“Merchant Issuer”</b>). The specifications, scope and the manner in which
              the solutions will be provided are set out in <b>Annexure A</b> hereto (“Project”).
        `,
        "bullet2": `The products covered by this Agreement consist of the gift cards, software
              applications and other devices, if any, provided by Pine Labs for the
              purposes of the Project.
        `,
        "bullet3": `The commercial terms agreed by the parties for the purposes of the Project
              are set out in <b>Annexure B</b> hereto.
        `,
        "bullet4": `The primary responsibilities of the Merchant Issuer are set out in Annexure
              C hereto. Each Party will designate a representative to act as the primary
              point- of-contact for the purposes of this Agreement.
        `,
        "bullet5": `
            Subject to the limitation of liability, each party shall indemnify, defend and
            hold harmless the other from and against any and all direct damages,
            liability, losses, costs and expenses (including reasonable attorneys’ fees)
            relating to or arising out of the breach of this Agreement, the negligence or
            willful misconduct of either party, or its employees or agents.
        `,
        "bullet6": `Pine Labs shall endeavor to ensure that its products and services meet the
              specifications set out herein in all material aspects, at the time of
              implementation. If the Merchant Issuer is of the opinion that Pine Labs
              products or services do not conform to the specifications set out herein,
              Pine Labs will use commercially reasonable efforts to correct or remedy
              such non-conformance.
        `,
        "bullet7": `For the avoidance of doubt, it is hereby clarified that the Merchant Issuer
              shall, at all times, be the issuer under law, of the gift cards issued under
              this Agreement. Pine Labs shall be the technology partner powering the gift
              card program, under instructions from the Merchant Issuer. Pine Labs
              products and services are provided on an “as is” basis. Except as
              expressly stated in Clause 6, Pine Labs hereby disclaims all express and
              implied warranties, including, without limitation, any implied warrantiesof
              merchantability and fitness for a particular purpose.
        `,
        "bullet8": `<b>Confidentiality:</b> Each party shall treat all data and information including
              the commercial terms and the terms and conditions agreed between the
              parties hereunder (including Cardholder information), (<b>"Confidential
                Information"</b>), disclosed to it or which comes into its possession or
              knowledge in connection with this arrangement as confidential. Further, the
              Merchant Issuer hereby agrees Pine Labs may use the personal
              information of the Merchant Issuer in any marketing or promotional
              activities associated with the Project at any time during the term of this
              Agreement.
        `,
        "bullet9": `Notwithstanding anything stated in this arrangement, both parties agree
              that all proprietary intellectual property including, software, computer
              programs and systems generated by Pine Labs, on the server/systems of
              Pine Labs in relation to this arrangement, shall be the sole and exclusive
              property of Pine Labs.
        `,
        "bullet10":`Merchant Issuer will not and will not permit others to: (i) copy, adapt, alter,
              modify, merge or create derivative works of Pine Labs software
              applications; (ii) reverse-engineer, disassemble, or decompile Pine Labs
              software applications or otherwise attempt to determine its underlying
              source code; or (iii) sell, lease, sublicense or provide any portion of Pine
              Labs’ software applications to any third party.
        `,
        "bullet11": `While data/information relating to Merchant Issuer such as name, address,
              trademark, logo etc.(Merchant Issuer Data) is the exclusive property of
              Customer, Pine Labs is authorized to have legal and physical access to
              and make use of all such Merchant Issuer Data for purpose of performing
              the Services provided by Pine Labs through its Distribution channels and
              social media to facilitate sale of Merchant Gift Card and for purposes of
              data analysis and marketing in accordance with Pine Labs Privacy Policy. .
              Pine Labs and Qwikcilver are Trademarks owned and operated by Pine
              Labs Private Limited.
        `,
        "bullet12": `Upon termination or expiration of this Agreement: (i) any and all payment obligations of Merchant Issuer that have accrued shall become immediately due and payable; (ii) products issued prior to termination shall continue to be valid till the expiry of the product and the parties shall fulfill their respective obligations with respect to those Cards as if the arrangement is not terminated; (iii) Merchant Issuer shall promptly return to Pine Labs, its confidential information, software applications and all materials provided pursuant to this Agreement; (iv) Merchant Issuer shall uninstall Pine Labs software applications installed on its systems; and (v) Pine Labs will provide to the Merchant Issuer, an updated MIS setting out the details of all transactions undertaken by the customers of the Merchant Issuer, upto the effective date of termination of this Agreement.`,
        "bullet13": `<b>Dispute Resolution:</b> Any and all disputes arising from this agreement shall be resolved through arbitration by a single arbitrator appointed by mutual agreement of the Parties, in accordance with the Arbitration and Conciliation Act, 1996.`,
        "bullet14": `<b>Governing Law and Jurisdiction:</b> This Agreement shall be governed by the laws of India. Subject to Clause 14 above, nothing contained in this clause will preclude either party from applying for and obtaining any injunctive, prohibitory or other similar urgent or interim relief from a competent court of law, for which the courts at Delhi shall have exclusive jurisdiction.`,
        "bullet15": `<b>Notices:</b> Any notices, requests and other communications required or permitted hereunder shall be in writing and shall be given by hand against written acknowledgement or receipt, or sent by registered mail, followed by a confirmation letter by registered mail, at or to each of the parties at the addresses set forth herein above.`,
        "bullet16": `<b>Amendments:</b> This Agreement can be modified, supplement or amended only by written agreement executed by both parties.`
    },
    "errorPage": {
        "notFound": "The page you’re looking for could not be found.",
        "backToHome": "Back to Home"
    }
}

export default en;